<template>
  <div class="amazon_edit" style="width: 90%">
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <div class="main">
      <el-form ref="basicForm" label-width="200px" :model="basicForm">
        <div id="basic" class="basic">
          <div class="title">基础信息</div>
          <el-form-item
            prop="templateName"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="模板名称："
          >
            <el-input
              :disabled="templateId.length > 0"
              size="mini"
              v-model="basicForm.templateName"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="designId || pId" prop="quantity" label="">
            <el-button
              size="small"
              type="primary"
              @click="priceConfigVisible = true"
              >指定颜色、尺码汇出</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="sizeColorVisible = true"
              >颜色、尺码名称自定义</el-button
            >
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            v-if="upload != '1'"
            prop="picRemitMode"
            label="图片汇出方式："
          >
            <el-radio-group v-model="basicForm.picRemitMode">
              <template v-for="record in dictData['picRemitMode']">
                <el-radio :label="record.value" :key="record.value">
                  {{ record.label }}</el-radio
                >
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="basicForm.picRemitMode == '01'"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            prop="productPicAddr"
            label="同步产品图片地址："
          >
            <el-select
              clearable
              style="width: 100%"
              size="mini"
              v-model="basicForm.productPicAddr"
              placeholder="请选择产品图片地址"
            >
              <el-option
                v-for="(record, index) in pictureAddresses"
                :key="index"
                :label="record"
                :value="record"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片分辨率设置：">
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin: 0 0 0 8px;
                  position: relative;
                "
                @click="showPicSize = true"
              >
                <span style="right: 10px; top: -2px; color: #409eff">
                  <span class="size_name_style is_main active"
                    ><span
                      ><i
                        class="el-icon-full-screen"
                        style="margin: 0 4px 0 0"
                      ></i
                      >尺寸调整（{{ basicForm.picSizeW }} x
                      {{ basicForm.picSizeH }}px）
                      <i
                        class="icon-screen_low f14 pa"
                        style="top: 0px; right: -14px"
                      ></i>
                    </span>
                  </span>
                </span>
              </div>
              <div
                v-if="showPicSize"
                style="
                  position: absolute;
                  left: 0px;
                  top: 39px;
                  z-index: 100;
                  padding: 8px;
                "
                class="imgSize-box active is_main"
              >
                <div class="cont">
                  <el-radio-group style="display: block" v-model="sizeConfig">
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1600"
                      >1600 x 1600px(默认)</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="800"
                      >800 x 800px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1200"
                      >1200 x 1200px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="2000"
                      >2000 x 2000px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0 0 0"
                      :label="0"
                      >自定义</el-radio
                    >
                  </el-radio-group>
                  <div v-if="sizeConfig == 0">
                    <input
                      placeholder="宽度"
                      v-model="picSizeW"
                      style="width: 60px; line-height: 24px; margin: 0 16px 0 0"
                    />
                    x
                    <input
                      v-model="picSizeH"
                      placeholder="高度"
                      style="width: 60px; line-height: 24px"
                    />
                  </div>
                </div>
                <div class="foot" style="text-align: center">
                  <el-button @click="showPicSize = false" size="small"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    @click="handleSavePicSize"
                    type="primary"
                    >保存</el-button
                  >
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="(platName == 'lazada' || platName == 'shopee') && designId"
            prop="saleForm"
            label="售卖形式:"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
          >
            <el-radio
              style="margin-right:4px;"
              v-model="basicForm.saleForm"
              label="01"
              >多颜色
            </el-radio>
            <el-tooltip
              class="item"
              effect="dark"
              content="汇出或上传时，1个主体多颜色变体展示，例：1个产品多个颜色切换"
              placement="top"
            >
              <i style="margin-right:18px;" class="el-icon-question"></i>
            </el-tooltip>

            <el-radio
              style="margin-right:4px;"
              v-model="basicForm.saleForm"
              label="02"
              >单颜色
            </el-radio>
            <el-tooltip
              class="item"
              effect="dark"
              content="汇出或上传时，多颜色产品展示，例：红色产品、蓝色产品等"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
        </div>
      </el-form>

      <div id="template" class="title">属性信息</div>
      <div>
        <div>
          <el-dropdown @command="handleCommand">
            <el-button
              v-if="platNo != '03' && platNo != '05'"
              size="small"
              type="primary"
            >
              添加属性<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="index"
                v-for="(record, index) in attrList"
                :key="index"
                >{{ record.attrName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-table :data="basicForm.attrList" style="width: 100%">
          <el-table-column prop="date" label="序号" width="180">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="attrName" label="属性名称" width="180">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.attrName == 'Category' ||
                    scope.row.attrName == 'Product Images1' ||
                    scope.row.attrName == 'Package Height (cm)' ||
                    scope.row.attrName == 'Package Width (cm)' ||
                    scope.row.attrName == 'Package Weight (kg)' ||
                    scope.row.attrName == 'Size' ||
                    scope.row.attrName == 'Color' ||
                    scope.row.attrName == 'SellerSKU' ||
                    scope.row.attrName == 'Stock' ||
                    scope.row.attrName == 'Package Length (cm)' ||
                    scope.row.attrName == 'Category' ||
                    scope.row.attrName == 'Product Description' ||
                    scope.row.attrName == 'Weight' ||
                    scope.row.attrName == 'Length' ||
                    scope.row.attrName == 'Width' ||
                    scope.row.attrName == 'Height' ||
                    scope.row.attrName == 'Price' ||
                    scope.row.attrName == 'Product Name'
                "
                style="color:red"
                >* </span
              >{{ scope.row.attrName }}
            </template>
          </el-table-column>
          <el-table-column prop="attrRemit" label="汇出字段名称" width="210">
          </el-table-column>
          <el-table-column prop="attrValue" label="属性值" width="210">
            <template slot-scope="scope">
              <div
                v-if="
                  (scope.row.attrName != '主图' &&
                    scope.row.attrName != '其他图片' &&
                    scope.row.attrName != '商品图片1' &&
                    scope.row.attrName != '商品图片2' &&
                    scope.row.attrName != '商品图片3' &&
                    scope.row.attrName != '商品图片4' &&
                    scope.row.attrName != '商品图片5' &&
                    scope.row.attrName != '商品图片6' &&
                    scope.row.attrName != '商品图片7' &&
                    scope.row.attrName != '商品图片8' &&
                    scope.row.attrName != 'Product Images1' &&
                    scope.row.attrName != 'Product Images2' &&
                    scope.row.attrName != 'Product Images3' &&
                    scope.row.attrName != 'Product Images4' &&
                    scope.row.attrName != 'Product Images5' &&
                    scope.row.attrName != 'Product Images6' &&
                    scope.row.attrName != 'Product Images7' &&
                    scope.row.attrName != 'Product Images8' &&
                    scope.row.attrName != 'Image per Variation' &&
                    scope.row.attrName != 'Cover image' &&
                    scope.row.attrName != 'Item image 1' &&
                    scope.row.attrName != 'Item image 2' &&
                    scope.row.attrName != 'Item image 3' &&
                    scope.row.attrName != 'Item image 4' &&
                    scope.row.attrName != 'Item image 5' &&
                    scope.row.attrName != 'Item image 6' &&
                    scope.row.attrName != 'Item image 7' &&
                    scope.row.attrName != 'Item image 8') ||
                    !scope.row.attrValue
                "
              >
                {{ scope.row.attrValue }}
              </div>
              <div v-else>
                <p
                  v-if="
                    (scope.row.attrName == '主图' ||
                      scope.row.attrName == '其他图片' ||
                      scope.row.attrName == '商品图片1' ||
                      scope.row.attrName == '商品图片2' ||
                      scope.row.attrName == '商品图片3' ||
                      scope.row.attrName == '商品图片4' ||
                      scope.row.attrName == '商品图片5' ||
                      scope.row.attrName == '商品图片6' ||
                      scope.row.attrName == '商品图片7' ||
                      scope.row.attrName == '商品图片8' ||
                      scope.row.attrName == 'Product Images1' ||
                      scope.row.attrName == 'Product Images2' ||
                      scope.row.attrName == 'Product Images3' ||
                      scope.row.attrName == 'Product Images4' ||
                      scope.row.attrName == 'Product Images5' ||
                      scope.row.attrName == 'Product Images6' ||
                      scope.row.attrName == 'Product Images7' ||
                      scope.row.attrName == 'Product Images8' ||
                      scope.row.attrName == 'Image per Variation' ||
                      scope.row.attrName == 'Cover image' ||
                      scope.row.attrName == 'Item image 1' ||
                      scope.row.attrName == 'Item image 2' ||
                      scope.row.attrName == 'Item image 3' ||
                      scope.row.attrName == 'Item image 4' ||
                      scope.row.attrName == 'Item image 5' ||
                      scope.row.attrName == 'Item image 6' ||
                      scope.row.attrName == 'Item image 7' ||
                      scope.row.attrName == 'Item image 8') &&
                      scope.row.attrValue &&
                      scope.row.attrValue.indexOf('http') == -1
                  "
                >
                  <span>效果图</span>{{ scope.row.attrValue }}
                </p>
                <img
                  style="width: 100px; height: 100px"
                  v-else
                  :src="scope.row.attrValue"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="handleEdit(scope.row, scope.$index)"
                >编辑
              </el-button>
              <el-button
                v-if="platNo != '03' && platNo != '05'"
                size="small"
                type="text"
                @click="handleUp(scope.$index)"
                >上移
              </el-button>
              <el-button
                v-if="platNo != '03' && platNo != '05'"
                size="small"
                type="text"
                @click="handleDown(scope.$index)"
                >下移
              </el-button>
              <el-button
                v-if="platNo != '03' && platNo != '05'"
                size="small"
                type="text"
                @click="handleDelete(scope.$index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="sidebar__style">
        <div class="list__style">
          <div v-if="templateId">
            <a class="text-link" href="#selectTemplate">选择模板</a>
          </div>
          <div><a class="text-link" href="#basic">基础信息</a></div>
          <div><a class="text-link" href="#template">属性信息</a></div>
        </div>
        <div @click="handleBackTop" class="button__style goTop__style">
          返回<br />顶部
        </div>
        <div @click="handleSave" class="button__style submit__style">
          保存<br />{{
            upload == "1" ? "待上传" : this.templateId ? "汇出" : "模板"
          }}
        </div>
      </div>
    </div>
    <VarHelp ref="varHelp" v-show="showVarHelp"></VarHelp>
    <PriceConfigDialog
      v-model="priceConfigVisible"
      @update="handleSetPrice"
    ></PriceConfigDialog>
    <SizeColorDialog
      :colorList="basicForm.colorList"
      :sizeList="basicForm.sizeList"
      v-model="sizeColorVisible"
      @update="handleSetColorSize"
    ></SizeColorDialog>

    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="750px"
      :before-close="handleClose"
    >
      <div class="main">
        <el-form ref="form" :model="form" label-width="119px">
          <el-form-item label="属性名称：">
            {{ form.attrName }}
          </el-form-item>
          <el-form-item
            prop="attrRemit"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="汇出字段名称："
          >
            <el-input
              style="width: 499px"
              size="small"
              v-model="form.attrRemit"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="form.attrName == 'Category'" label="属性值：">
            <div>
              <el-select
                clearable
                filterable
                v-model="form.attrValue"
                placeholder="请选择"
                class="input"
                size="small"
              >
                <el-option
                  v-for="(value, index) in dictData['shopeeCategory']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item v-else-if="formType == 'normal'" label="属性值：">
            <div>
              <div class="variable-insert">
                <div class="insert-link">
                  插入变量
                  <div class="variable-select-menu">
                    <ul>
                      <li
                        class="variable-select-box-text"
                        :key="number"
                        v-for="(record, number) in varList"
                        @click="handleInsertVariable(record.var)"
                      >
                        {{ record.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <i
                  @mouseenter="handleShowVarHelp"
                  @mouseout="showVarHelp = false"
                  class="el-icon-question"
                ></i>
              </div>
              <textarea
                style="width: 499px !important"
                :id="`textarea_attr_value`"
                :ref="`textarea_attr_value`"
                type="textarea"
                placeholder="请输入内容"
                v-model="form.attrValue"
                show-word-limit
                :rows="6"
                size="mini"
              >
              </textarea>
            </div>
          </el-form-item>

          <el-form-item v-else style="margin-bottom: 0" label="属性值：">
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="imageGroup"
                style="overflow: hidden; display: inline-block"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in imageGroup"
                  :key="index"
                  class="sort-img-item"
                  :class="index === 0 ? 'forbid' : ''"
                >
                  <div
                    @click="handleDeleteImage"
                    v-if="record.isMain"
                    class="item-badge"
                  >
                    删除
                  </div>
                  <p v-if="record.imageUrl.indexOf('http') === -1">
                    效果图{{ record.imageUrl }}
                  </p>
                  <img v-else :src="record.imageUrl" />
                  <span class="first-pro-icon icon-corner-mark"></span>
                </li>
              </draggable>
              <li
                class="forbid"
                :class="{ 'add-image-button': true }"
                v-if="imageGroup.length < 1"
              >
                <p><i class="el-icon-plus"></i></p>
                <div class="variable-select-box">
                  <ul>
                    <li>
                      插入变量
                      <ul class="variable-pick-ul">
                        <li
                          @click="handleAddSample(record)"
                          v-for="record in imageSamples"
                          :key="record"
                        >
                          效果图{{ record }}
                        </li>
                      </ul>
                    </li>
                    <li @click="handleUploadImage">本地图片</li>
                  </ul>
                </div>
              </li>
            </ul>
          </el-form-item>
          <el-form-item style="margin: -35px 0 0 0;font-size:12px;" label="">
            <div
              v-if="form.attrName == 'Product Name' && platNo == '03'"
              style="color:#999999;"
            >
              此字段需在5-255个字符以上，不允许带特殊字符
            </div>
            <div
              v-if="
                form.attrName == 'Long Description (Lorikeet)' && platNo == '03'
              "
              style="color:#999999;"
            >
              此字段需在20-3000个字符以上
            </div>
            <div
              v-if="form.attrName == 'Product Name' && platNo == '05'"
              style="color:#999999;"
            >
              此字段需在20个字符以上，不允许带特殊字符
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleAddAttr"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import BasicControl from "../amazon/components/basicControl";
import { getProList } from "@/api/plat/platType";
import Breadcrumb from "@/components/common/Breadcrumb";
import { mapGetters } from "vuex";
import { getProductTypeList, getTemplateTypeList } from "@/api/plat/platType";
import { addTemplate, getTemplateInfo, addRemit, addAmazonRemit, getVarListDesign, getVarListColl, getVarList, listDefault } from "@/api/template/universal";
import { getOSSToken } from "@/api/setting";
import { getConfigKey } from "@/api/system/config";
import VarHelp from '../amazon/components/varHelp.vue'
import PriceConfigDialog from '../amazon/components/PriceConfigDialog'
import SizeColorDialog from '../amazon/components/SizeColorDialog'
import draggable from "vuedraggable"
import { listDesignColorsize, listAmazonColorsize } from "@/api/template/template";
import { getDomainList, } from "@/api/system/domain"

export default {
  name: "createTemplate",
  components: { BasicControl, Breadcrumb, VarHelp, PriceConfigDialog, SizeColorDialog ,draggable },
  props: {
    templateId : {
      type : String,
      default: ''
    },
    shopId : {
      type : String,
      default: ''
    },
    designId : {
      type : String,
      default: ''
    }
  },
  data() {
    return {
      basicForm: {
        templateName: "",
        picRemitMode: "01",
        productPicAddr: "",
        attrList: [],
        skuList: [],
        colorList: [],
        sizeList: [],
        picSizeH: '800',
        picSizeW: '800',
        saleForm: '01'
      },
      sizeConfig: 800,
      showPicSize: false,
      picSizeH: '',
      picSizeW: '',
      form: {
        attrId: '',
        attrName: '',
        attrRemit: '',
        attrValue: ''
      },
       pictureAddresses: [],
       priceConfigVisible: false,
       sizeColorVisible: false,
       pId: '',
       showVarHelp: false,
       attrList: [],
       dialogVisible: false,
       dialogTitle: '添加属性',
       editIndex: -1,
       imageSamples: ["1","2","3","4","5","6","7","8","9","10","11","12"],
       imageGroup: [],
       varList: [],
       formType: 'normal',
       aliyunOssToken: {},
       platNo: '',
       upload: '0',
       platName: ''
    };
  },
 watch: {
    templateId: {
      handler(){
        if(this.templateId){
          this.loadData(this.templateId)
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
      getOssToken() {
      var _self = this
      getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
     getConfigKey(){
      getConfigKey("pic_url")
        .then(async (res) => {
         if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async listDefault(){

      let result =  await listDefault({platNo: this.platNo})
      for(let record of result.rows){
        record.attrRemit = record.attrDefaultRemit
        record.attrValue = record.attrDefaultValue
      }
      this.attrList = result.rows
    },
    handleSavePicSize(){
      if(this.sizeConfig == 0){
        if(!this.picSizeW ){
          this.msgError('请输入宽度')
          return
        }
        if(!this.picSizeH){
          this.msgError('请输入高度')
          return
        }
        this.basicForm.picSizeW = this.picSizeW
        this.basicForm.picSizeH = this.picSizeH
      }else if(this.sizeConfig == 1600){
        this.basicForm.picSizeW = '1600'
         this.basicForm.picSizeH = '1600'
      }else if(this.sizeConfig == 800){
        this.basicForm.picSizeW = '800'
         this.basicForm.picSizeH = '800'
      }
      else if(this.sizeConfig == 1200){
        this.basicForm.picSizeW = '1200'
         this.basicForm.picSizeH = '1200'
      }
      else if(this.sizeConfig == 2000){
        this.basicForm.picSizeW = '2000'
        this.basicForm.picSizeH = '2000'
      }
      this.showPicSize = false
    },
     handleBackTop(){
      window.scroll(0,0)
    },
      handleUploadImage(){
      document.querySelector('#fileUpload').click()
    },
    async loadData(templateId){
      if(templateId){
        let result = await getTemplateInfo(templateId)
        if(!result.data.saleForm){
          result.data.saleForm = '01'
        }
        this.basicForm = result.data
        this.initPicSizeConfig()
        let pId = this.$route.query.pId
        let designId = this.$route.query.designId
        if(designId){
          this.designId = designId
          this.templateId = templateId
          let result = await listDesignColorsize({
            templateId: templateId,
            designId: designId,
          })
            this.basicForm.colorList = result.data.colorList
            this.basicForm.sizeList = result.data.sizeList
          }
          if(pId){
          let result = await listAmazonColorsize({
            templateId: this.templateId,
            pId: pId,
          })
          this.basicForm.colorList = result.data.colorList
          this.basicForm.sizeList = result.data.sizeList
        }


      }else{
        let platNo = this.platNo
        if(platNo == '09'){
          this.basicForm.attrList = [{"attrId":"10001","attrName":"父SKU","attrRemit":"Parent SKU","attrValue":"{id}"},
            {"attrId":"10002","attrName":"子SKU","attrRemit":"Child SKU","attrValue":"{id}"},
            {"attrId":"10004","attrName":"主题名称","attrRemit":"Design Name","attrValue":"{designName}"},
            {"attrId":"10007","attrName":"颜色","attrRemit":"Color","attrValue":"{color}"},
            {"attrId":"10008","attrName":"尺码","attrRemit":"Size","attrValue":"{size}"},
            {"attrId":"10010","attrName":"主图","attrRemit":"Main Image URL","attrValue":"1"},
            {"attrId":"10011","attrName":"其他图片","attrRemit":"Other Image URL","attrValue":"1"},
            {"attrId":"10011","attrName":"其他图片","attrRemit":"Other Image URL","attrValue":"2"},
            {"attrId":"10012","attrName":"英文产品描述","attrRemit":"English Product Description","attrValue":"{englishProductDescription}"},
            {"attrId":"10013","attrName":"底板英文标题","attrRemit":"English Product Name","attrValue":"{englishProductName}"},
          ]
        } else if(platNo == '03' || platNo == '05'){
          let attrList = JSON.parse(JSON.stringify(this.attrList))
          for(let record of attrList){
            if(record.attrValue){
               record.attrValue = record.attrValue.replace('效果图','')
            }
          }
         this.basicForm.attrList = attrList
        }

      }
    },
    handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.imageGroup.push({
              imageUrl: fileUrl,
              isMain: _self.imageGroup.length === 0 ? true : false
            })
            _self.form.attrValue = fileUrl
            $("#fileUpload").val(null)
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
      handleSetColorSize(record){
      this.basicForm.colorList = record.colorList
      this.basicForm.sizeList = record.sizeList
    },
    async getVarList(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if (pId) {
        let result = await getVarListColl()
        this.varList = result.rows
      }  else if(designId) {
        let result = await getVarListDesign()
        this.varList = result.rows
      }else {
          let result = await getVarList()
        this.varList = result.rows
      }
    },
    handleInsertVariable(value){
      this.insertAtCursor(value)
    },
    async insertAtCursor(value) {
      var myValue = value
      const myField = document.querySelector('#textarea_attr_value')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.form.attrValue = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        this.form.attrValue = (this.form.attrValue ? this.form.attrValue : '') + value
      }
    },
    async handleInsertColorSize(value){
      var myValue = value
      const myField = document.querySelector('#textarea_color')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.basicForm.color_name = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        this.basicForm.color_name = (this.basicForm.color_name ? this.basicForm.color_name : '') + value
      }
    },
      handleShowVarHelp(event){
      this.$refs['varHelp'].$el.style.top = event.clientY + 'px'
      this.showVarHelp = true
    },
    handleSave(){
      this.$refs['basicForm'].validate(async (valid)=>{
        if(valid){
          let form = this._.clone(this.basicForm)
          let action = this.$route.query.action
          let designId = this.$route.query.designId
          if(designId){
            designId = designId.split(',')
          }
          let skuNum = this.$route.query.skuNum
          let platNo = this.platNo
          form.platNo = platNo
          if(this.upload == '1'){
            form.remitMode = '02'
          }
          if(action == 'copy'){
            form.templateId = ''
          }
          //判断SKU数量是否合法
          if(platNo == '05' && designId &&  skuNum){
            let skus = []
            skuNum = skuNum.split(',')
            for(let i=0;i<designId.length;i++){
              skus.push({
                designId: designId[i],
                skuNum: skuNum[i],
                skuNumReal: 0,
              })
            }
            if(!this.basicForm.skuList){
              for(let record of skus){
                if(record.skuNum > 50){
                  this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
                  return
                }
              }
            }else {
              for(let record of this.basicForm.skuList){
                for(let sku of skus){
                  if(record.designId == sku.designId){
                    sku.skuNumReal++;
                    break
                  }
                }
              }
              for(let record of skus){
                if(record.skuNumReal > 50){
                  this.msgError('汇出数据中单品有超过50个sku，官方限制上传，需在指定颜色、尺码汇出按钮设置筛选汇出颜色')
                  return
                }
              }
            }
          }
          if(platNo == '05'){
            for(let record of form.attrList){
              if(record.attrName == 'Category' && !record.attrValue){
                this.msgError('Category字段需要必填')
                return
              }
                if(record.attrName == 'Product Name' && !record.attrValue){
                this.msgError('Product Name字段需要必填')
                return
              }
                if(record.attrName == 'Product Description' && !record.attrValue){
                this.msgError('Product Description字段需要必填')
                return
              }
               if(record.attrName == 'Price' && !record.attrValue){
                this.msgError('Price字段需要必填')
                return
              }
                if(record.attrName == 'Stock' && !record.attrValue){
                this.msgError('Stock字段需要必填')
                return
              }

                if(record.attrName == 'Weight' && !record.attrValue){
                this.msgError('Weight字段需要必填')
                return
              }
                if(record.attrName == 'Length' && !record.attrValue){
                this.msgError('Length字段需要必填')
                return
              }
                if(record.attrName == 'Width' && !record.attrValue){
                this.msgError('Width字段需要必填')
                return
              }
                  if(record.attrName == 'Height' && !record.attrValue){
                this.msgError('Height字段需要必填')
                return
              }


            }
          }
          if(platNo == '03'){
            for(let record of form.attrList){
                if(record.attrName == 'Product Images1' && !record.attrValue){
                this.msgError('Product Images1字段需要必填')
                return
              }
                if(record.attrName == 'Package Height (cm)' && !record.attrValue){
                this.msgError('Package Height (cm)字段需要必填')
                return
              }
                if(record.attrName == 'Package Width (cm)' && !record.attrValue){
                this.msgError('Package Width (cm)字段需要必填')
                return
              }
                if(record.attrName == 'Package Weight (kg)' && !record.attrValue){
                this.msgError('Package Weight (kg)字段需要必填')
                return
              }
                if(record.attrName == 'Size' && !record.attrValue){
                this.msgError('Size字段需要必填')
                return
              }
                if(record.attrName == 'Color' && !record.attrValue){
                this.msgError('Color字段需要必填')
                return
              }
                if(record.attrName == 'SellerSKU' && !record.attrValue){
                this.msgError('SellerSKU字段需要必填')
                return
              }
                if(record.attrName == 'Stock' && !record.attrValue){
                this.msgError('Stock字段需要必填')
                return
              }
                if(record.attrName == 'Package Length (cm)' && !record.attrValue){
                this.msgError('Package Length (cm)字段需要必填')
                return
              }
                if(record.attrName == 'Price' && !record.attrValue){
                this.msgError('Price字段需要必填')
                return
              }

            }
          }

          try {
            if(this.templateId){
              form.templateId = this.templateId
              form.shopId = this.shopId

              if(this.pId){
                form.pId = this.pId
                await addAmazonRemit(form)
                this.msgSuccess("汇出成功，请到汇出记录中下载");
              }
              if(this.designId){
                 if(this.upload == '1'){
                  for(let i=0;i<designId.length;i++){
                    form.designId = designId[i]
                    let currentForm = this._.clone(form)
                    if(currentForm.skuList){
                      currentForm.skuList = currentForm.skuList.filter(record=>{
                        return record.designId == designId[i]
                      })
                    }
                    await addRemit(currentForm)
                  }
                 } else{
                    form.designId = this.designId
                    await addRemit(form)
                 }
                this.msgSuccess("汇出成功，请到汇出记录中下载");
              }
            }
            else{
              await addTemplate(form);
              this.msgSuccess("保存成功");
            }
            this.$emit('submit')
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    handleSetPrice(value){
      this.basicForm.skuList = value
    },
     onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
    },
    handleUp(index){
      let table = this._.clone(this.basicForm.attrList)
      if(index == 0){
        return
      }
      let object = table[index - 1]
      table[index - 1] = table[index]
      table[index] = object
      this.basicForm.attrList = table
    },
    handleEdit(row, index){
      this.dialogTitle = '编辑属性'
      this.form = this._.clone(row)
      if(this.form.attrName == '主图'
      || this.form.attrName == '其他图片'
      || this.form.attrName == '商品图片1'
      || this.form.attrName == '商品图片2'
      || this.form.attrName == '商品图片3'
      || this.form.attrName == '商品图片4'
      || this.form.attrName == '商品图片5'
      || this.form.attrName == '商品图片6'
      || this.form.attrName == '商品图片7'
      || this.form.attrName == '商品图片8' ||
      this.form.attrName == 'Product Images1' ||
      this.form.attrName == 'Product Images2' ||
      this.form.attrName == 'Product Images3' ||
      this.form.attrName == 'Product Images4' ||
      this.form.attrName == 'Product Images5' ||
      this.form.attrName == 'Product Images6' ||
      this.form.attrName == 'Product Images7' ||
      this.form.attrName == 'Product Images8'||
      this.form.attrName == 'Image per Variation'||
      this.form.attrName == 'Cover image' ||
      this.form.attrName == 'Item image 1' ||
      this.form.attrName == 'Item image 2'||
      this.form.attrName == 'Item image 3'||
      this.form.attrName == 'Item image 4'||
      this.form.attrName == 'Item image 5'||
      this.form.attrName == 'Item image 6'||
      this.form.attrName == 'Item image 7'||
      this.form.attrName == 'Item image 8'

      ){
        this.getOssToken()
        this.formType = 'image'
        if(this.form.attrValue){
          this.imageGroup = [{
            imageUrl: this.form.attrValue,
            isMain: true
          }]
        }
      } else{
        this.formType = 'normal'
      }
      this.editIndex = index
      this.dialogVisible = true
    },
    handleDown(index){
      let table = this._.clone(this.basicForm.attrList)
      if(index == this.basicForm.attrList.length - 1){
        return
      }
      let object = table[index + 1]
      table[index + 1] = table[index]
      table[index] = object
      this.basicForm.attrList = table
    },
    handleDelete(index){
      let table = this._.clone(this.basicForm.attrList)
      table.splice(index, 1)
      this.basicForm.attrList = table
    },
    handleCommand(index){
      // let form = this.attrList[index]
      this.form.attrRemit =  this.attrList[index].attrDefaultRemit
      this.form.attrValue = this.attrList[index].attrDefaultValue
      this.form.attrName = this.attrList[index].attrName
      this.form.attrId  = this.attrList[index].attrId
      this.imageGroup = []
      if(this.form.attrName == '主图' || this.form.attrName == '其他图片'){
        this.getOssToken()
        this.formType = 'image'
        this.form.attrValue = ''
      } else{
        this.formType = 'normal'
      }
      // this.form = form
      this.dialogTitle = '添加属性'
      this.dialogVisible = true
      this.editIndex = -1
      this.$nextTick(()=>{
        this.$refs['form'].clearValidate()
      })
    },
    handleClose() {
       this.dialogVisible = false
      },
    handleAddAttr(){
      this.$refs['form'].validate((valid)=>{
        if(valid){
          // if(this.imageGroup.length == 0 && this.formType == 'image'){
          //   this.msgError('请输入属性值')
          //   return
          // }
          if(this.editIndex == -1){
            this.basicForm.attrList.push(
            this._.clone(this.form))
          } else{
            this.basicForm.attrList[this.editIndex] = this._.clone(this.form)
          }
          this.basicForm = JSON.parse(JSON.stringify(this.basicForm))
          this.dialogVisible = false
        }
      })
    },
    async getTemplate(){
      let templateId = this.$route.query.templateId
      if(templateId){
        let result = await getTemplateInfo(templateId)
        if(!result.data.saleForm){
          result.data.saleForm = '01'
        }
        this.basicForm = result.data
        this.initPicSizeConfig()
      }
    },
    initPicSizeConfig(){
        if(this.basicForm.picSizeW && this.basicForm.picSizeH ){
          if(this.basicForm.picSizeW == 1600 && this.basicForm.picSizeH  == 1600){
            this.sizeConfig = 1600
          } else if(this.basicForm.picSizeW == 800 && this.basicForm.picSizeH  == 800){
            this.sizeConfig = 800
          }else if(this.basicForm.picSizeW == 1200 && this.basicForm.picSizeH  == 1200){
            this.sizeConfig = 1200
          }else if(this.basicForm.picSizeW == 2000 && this.basicForm.picSizeH  == 2000){
            this.sizeConfig = 2000
          } else{
            this.sizeConfig = 0
            this.picSizeW = this.basicForm.picSizeW
            this.picSizeH = this.basicForm.picSizeH
          }
        } else {
          this.sizeConfig = 800
          this.basicForm.picSizeW = 800
          this.basicForm.picSizeH = 800
        }

    },
    handleAddSample(record){
      this.imageGroup.push({
        imageUrl: record,
        isMain: this.imageGroup.length === 0 ? true : false
      })
      this.form.attrValue = record
    },
    handleDeleteImage(){
      this.imageGroup = []
      this.form.attrValue = ''
    }
 },
 async mounted() {
   let platNo  = this.$route.query.platNo
   let upload =  this.$route.query.upload
   let platName = this.$route.query.platName
   this.upload = upload
   this.platName = platName
   platNo = platNo ? platNo : '09'
   this.platNo = platNo
   this.getConfigKey()
   await this.listDefault()
   this.getTemplate()
   this.getVarList()
   let templateId = this.$route.query.templateId || this.templateId
   if(!templateId){
    this.loadData()
   }
  },
};
</script>

<style lang="scss" scoped>
.main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #409eff;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 600px;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  li.sort-img-item {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > div > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > div > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  li.add-image-button > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope,
  .detail-image-ul.lazada > div > li .wish-product-img-ope,
  .wish-product-img > div > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: #3ba5ea;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > div > li .wish-product-img-ope > a,
  .wish-product-img > div > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: #409eff;
    font-weight: bold;
    font-size: 14px;
    bottom: -8px;
    right: 6px;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
    cursor: pointer;
  }
  .add-image-button {
    font-size: 24px;
    vertical-align: 15px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #409eff;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #409eff;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  right: 0;
  text-align: right;
  top: 20px;
  line-height: 20px;
}
.com-search-input {
  height: 28px;
  border: 1px solid rgb(225, 227, 229);
  vertical-align: top;
}
select {
  color: rgb(89, 90, 90);
  border-radius: 4px;
  width: 100%;
}

input:focus,
textarea:focus,
select:focus,
textarea:focus {
  border: 1px solid #409eff;
  box-shadow: 0 0 2px #a3c3f9;
  outline: none;
}
.w70 {
  width: 70% !important;
}
.w100 {
  width: 100% !important;
}
.imgSize-box {
  background: #fff;
  border: 1px solid rgb(221, 221, 221);
  min-width: 160px;
  p {
    padding: 7px 10px;
    font-size: 12px;
    line-height: 26px;
  }
  .ml5 {
    margin-left: 5px !important;
  }
}
</style>
